import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import QuoteFormPage from './pages/QuoteFormPage';


const App = () => {
  return (
    <Router>
      <div className="bg-[#FFF]">
         <ScrollToTop />
        <Routes>
          <Route path='/' element={<QuoteFormPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
